export const TRANSLATE_BACKEND_URL = '/ox/4.0/i18n/{{lng}}'; // http-backend only interpolates {{lng}}/{{ns}}
export const APIGEE_TRANSLATE_BACKEND_URL = '/apigee/ox/4.0/i18n/{{lng}}'; // new SSO path
export const EN_LOCALE = 'en_US';
export const JP_LOCALE = 'ja_JP';
export const LANGUAGE_LOCAL_STORAGE_KEY = 'language';
export const LANGUAGES = [EN_LOCALE, JP_LOCALE];
